/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { formList } from '@mantine/form'
import {
  includes,
  isArray,
  isDate,
  isNull,
  isPlainObject,
  isString,
  isUndefined,
  parseInt,
  result,
  toString,
} from 'lodash'
import { z } from 'zod'

export type operation = 'query' | 'create' | 'update'

export const doNoting = (a: any) => a

export const on =
  (operation: operation) =>
  (on: operation | Array<operation>) =>
  (callback: (a: any) => any) => {
    if ((isArray(on) && includes(on, operation)) || operation === on)
      return callback
    return doNoting
  }

export const dateParser = z.preprocess(arg => {
  if (isString(arg) || isDate(arg)) return new Date(arg)
}, z.date().nullish())

export const keywordsToMantineFormList = (arg: Array<string>) => arg.join(', ')
//formList(arg.map(v => (v)))
export const keywordsTransformer = (arg: string) => arg.split(',')

export const imagesToMantineFormList = (arg: Array<string>) =>
  formList(arg.map(v => ({ imageUrl: v })))
export const arrayToMantineFormList = (arg: Array<any>) =>
  arg ? formList(arg) : formList([])

export const backgroundImagesTransformer = (arr: Array<{ imageUrl: string }>) =>
  arr.map((v: any) => v.imageUrl)

export const backgroundSponsorshipImagesTransformer = (
  arr: Array<{ imageUrls: string[]; name: string; key: string }>,
) => arr.map((v: any) => v)

export const connectWithId = (v: any) => {
  const isValidId = v !== '' && !isNull(v) && !isUndefined(v)
  const res = isValidId
    ? {
        connect: { id: parseInt(v) },
      }
    : undefined
  return res
}
export const parseIdFromObj = (v: any) =>
  isPlainObject(v) ? toString(result(v, 'id', '')) : undefined

export const set = (v: any) => {
  const isValid = !isNull(v) && !isUndefined(v)
  return isValid ? { set: v } : undefined
}
export const update = (v: any) => {
  const isValid = !isNull(v) && !isUndefined(v)
  return isValid ? { update: v } : undefined
}

export const oneToOne = (
  _: (
    on: operation | operation[],
  ) => (callback: (a: any) => any) => (a: any) => any,
) =>
  z
    .object({ id: z.number() })
    .or(z.string())
    .transform(_(['create', 'update'])(connectWithId))
    .transform(_(['query'])(parseIdFromObj))

export const oneToOneNullish = (
  _: (
    on: operation | operation[],
  ) => (callback: (a: any) => any) => (a: any) => any,
) =>
  z
    .object({ id: z.number() })
    .or(z.string())
    .nullish()
    .transform(_(['create', 'update'])(connectWithId))
    .transform(_(['query'])(parseIdFromObj))
